<template>
    <div class="mb-4">
        <h5>{{ $t('Legal Personal Information') }}</h5>
        <div class="px-0 mt-3">
            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Name of Legal Entity') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" placeholder="Legal Name" v-model="params.legalName" @keydown="onChange('legalName')"/>
                    <div v-if="error['legalName']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalName'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Legal Representative') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" placeholder="Legal Representative" v-model="params.legalRepresentative" @keydown="onChange('legalRepresentative')"/>
                    <div v-if="error['legalRepresentative']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalRepresentative'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Type of Certificate') }} <span class="text-danger">*</span></label>
                </b-col>
                <b-col sm="12" md="9">
                    <NewDocOption 
                        :data="doc_type_list"
                        :ref="'doc_type'"
                        @selected-document="selectedDocument($event)">
                    </NewDocOption>
                    <div v-if="error['legalIdType']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalIdType'])}}
                    </div>
                </b-col>
            </b-row>

            <!-- <b-row class="mb-3" v-if="params.legalIdType==2">
                <b-col cols="12" md="3">
                    <label>{{ $t('Nationality') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <Select2 v-model="params.nationality" :options='nationalityOpt' @select="onChange('nationality')" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Nationality") }' class="form-control"/>
                    <div v-if="error['nationality']" class="invalid-feedback d-block mb-3">
                        {{$t(error['nationality'])}}
                    </div>
                </b-col>
            </b-row> -->

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('ID Photo') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="3">
                    <div class="d-flex justify-content-center">
                        <label class="pt-2">{{ $t('ID Photo Front Side') }} <span class="text-danger">*</span></label>
                        <span class="position-relative">
                            <button type="button" class="flat-button position-absolute" @click="togglePopup(1)">
                            <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                            </button>
                            <NewPopupInfo :name="(params.legalIdType==1?'ic':'passport')+'_front'" v-if="showPopup_1" :addClass="'popup-info-center'"></NewPopupInfo>
                        </span>
                    </div>
                    <FileUploader  
                        :type="'browse'"
                        :allowed_types = "['jpg','jpeg', 'png']"
                        :size="4*1024*1024"
                        :ref="'legalIdFront'"
                        @capture-file="captureFile($event,'legalIdFront')" 
                        @remove-image="removeImage($event,'legalIdFront')"
                        @toggle-camera="toggleCamera($event)">
                    </FileUploader>
                    <div v-if="error['legalIdFront']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalIdFront'])}}
                    </div>
                </b-col>
                <b-col sm="12" md="3" v-if="params.legalIdType == 1">
                    <div class="d-flex justify-content-center">
                        <label class="pt-2">{{ $t('ID Photo Back Side') }} <span class="text-danger">*</span></label>
                        <span class="position-relative">
                            <button type="button" class="flat-button position-absolute" @click="togglePopup(2)">
                            <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                            </button>
                            <NewPopupInfo :name="(params.legalIdType==1?'ic':'passport')+'_national'" v-if="showPopup_2" :addClass="'popup-info-center'"></NewPopupInfo>
                        </span>
                    </div>
                    <FileUploader  
                        :type="'browse'"
                        :allowed_types = "['jpg','jpeg', 'png']"
                        :size="4*1024*1024"
                        :ref="'legalIdReverse'"
                        @capture-file="captureFile($event,'legalIdReverse')" 
                        @remove-image="removeImage($event,'legalIdReverse')"
                        @toggle-camera="toggleCamera($event)">
                    </FileUploader>
                    <div v-if="error['legalIdReverse']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalIdReverse'])}}
                    </div>
                </b-col>
                <b-col sm="12" md="3">
                    <div class="d-flex justify-content-center">
                        <label class="pt-2">{{ $t('Holding ID Card') }} <span class="text-danger">*</span></label>
                        <span class="position-relative">
                            <button type="button" class="flat-button position-absolute" @click="togglePopup(3)">
                            <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                            </button>
                            <NewPopupInfo :name="(params.legalIdType==1?'ic':'passport')+'_holding'" v-if="showPopup_3" :addClass="'popup-info-center'"></NewPopupInfo>
                        </span>
                    </div>
                    <FileUploader  
                        :type="'browse'"
                        :allowed_types = "['jpg','jpeg', 'png']"
                        :size="4*1024*1024"
                        :ref="'legalIdHold'"
                        @capture-file="captureFile($event,'legalIdHold')" 
                        @remove-image="removeImage($event,'legalIdHold')"
                        @toggle-camera="toggleCamera($event)">
                    </FileUploader>
                    <div v-if="error['legalIdHold']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalIdHold'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Province') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.legalProvince" :options="provinceOpt" @select="onSelectProvince($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("Province")}' class="form-control"/>
                        <div v-if="error['legalProvince']" class="invalid-feedback d-block mb-3">
                            {{$t(error['legalProvince'])}}
                        </div>
                    </div>
                </b-col>
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('City') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.legalCity" :options="cityOpt" @select="onSelectCity($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("City")}' class="form-control"/>
                        <div v-if="error['legalCity']" class="invalid-feedback d-block mb-3">
                            {{$t(error['legalCity'])}}
                        </div>
                    </div>
                </b-col>
                <b-col xl="4" sm="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('District') }} <span class="text-danger">*</span></label>
                        <Select2 v-model="params.legalArea" :options="districtOpt" @select="onSelectDistrict($event)" :settings='{ escapeMarkup: doEscapeMarkup,placeholder:$t("District")}' class="form-control"/>
                        <div v-if="error['legalArea']" class="invalid-feedback d-block mb-3">
                            {{$t(error['legalArea'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-4">
                <b-col xl="12">
                    <div class="form-group mb-0">
                        <label>{{ $t('Address') }} <span class="text-danger">*</span></label>
                        <input type="text" name="legalAddress" v-model="params.legalAddress" class="form-control" @keydown="addressCondition($event)" @keyup="onchangeAddress($event)"/>
                        <div v-if="error['legalAddress']" class="invalid-feedback d-block mb-3">
                            {{$t(error['legalAddress'])}}
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Validity Period of Legal Person Certificate') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <date-picker v-model="params.legalCertExpiryDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('legalCertExpiryDate')"></date-picker>
                    <div v-if="error['legalCertExpiryDate']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalCertExpiryDate'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Date of Birth') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <date-picker v-model="params.legalBirthDate" :lang="lang_date" input-class="form-control" format="YYYY-MM-DD" value-type="YYYY-MM-DD" @change="onChange('legalBirthDate')"></date-picker>
                    <div v-if="error['legalBirthDate']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalBirthDate'])}}
                    </div>
                </b-col>
            </b-row>

            <b-row class="mb-3">
                <b-col cols="12" md="3">
                    <label>{{ $t('Legal Person ID Number') }} <span class="text-danger">*</span></label>
                </b-col>

                <b-col sm="12" md="9">
                    <input type="text" class="form-control" placeholder="Legal ID Number" v-model="params.legalIdNo" @keydown="onChange('legalIdNo')"/>
                    <div v-if="error['legalIdNo']" class="invalid-feedback d-block mb-3">
                        {{$t(error['legalIdNo'])}}
                    </div>
                </b-col>
            </b-row>
        </div>
        
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2 from 'v-select2-component';

import NewDocOption from "@/components/Kyc/NewDocOption";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';

import 'vue2-datepicker/locale/zh-cn';
import 'vue2-datepicker/locale/zh-tw';
import 'vue2-datepicker/locale/ja';
import 'vue2-datepicker/locale/en';

export default {
  data() {
    return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        cityOpt:[],
        districtOpt:[],
        provinceOpt:[],
        lang_date:'en',
        maxSize:4,
        showPopup_1:false,
        showPopup_2:false,
        showPopup_3:false,
        success:null,
        userNo:null,
        accountId:null,
        file:{
            legalIdFront:null,
            legalIdReverse:null,
            legalIdHold:null,
        },
        params:{
            legalIdFront:'',
            legalIdReverse:'',
            legalIdHold:'',
            legalIdType:'',
            legalName:'',
            legalRepresentative:'',
            legalProvince:'',
            legalCity:'',
            legalArea:'',
            legalAddress:'',
            legalCertExpiryDate:'',
            legalBirthDate:'',
            legalIdNo:''
        },
        error:{
            legalIdType:'',
            legalIdFront:'',
            legalIdReverse:'',
            legalIdHold:'',
            legalName:'',
            legalRepresentative:'',
            legalProvince:'',
            legalCity:'',
            legalArea:'',
            legalAddress:'',
            legalCertExpiryDate:'',
            legalBirthDate:'',
            legalIdNo:''
        }
    }
  },
  components:{
    NewDocOption,
    FileUploader,
    Select2,
    NewPopupInfo,
    DatePicker
  },
  props:['doc_type_list','information','user_no','account_id'],
  methods:{
    getFile(index,file_id){
        let self = this;
        CreateAccount.getFile({fileId:file_id}).then(response => {
            let data_file = response.data.data[0];
            if(data_file.type == 2 || data_file.type == 5){
                self.params.legalIdFront = data_file.file;
                self.$refs['legalIdFront'].image =data_file.file;
            }
            else if(data_file.type == 4 || data_file.type == 6){
                self.params.legalIdHold = data_file.file;
                self.$refs['legalIdHold'].image =data_file.file;
            }
            else if(data_file.type == 3){
                self.params.legalIdReverse = data_file.file;
                self.$refs['legalIdReverse'].image =data_file.file;
            }
        });
    },
    addressCondition($event){
        if($event.keyCode == 13){
            $event.preventDefault();
        }
        this.onChange('legalAddress');
    },
    onchangeAddress($event){
        let msg = $event.target.value.replace("\n", " ");
        $event.target.value = msg;
    },
    onSelectDistrict({id,text}){
        var self = this;
        this.onChange('legalArea');
    },
    onSelectCity({id,text,code}){
        var self = this;
        this.onChange('legalCity');
        if(text){
            this.legalArea="";
        }
        this.getDistrict(code);
    },
    onSelectProvince({id,text,code}){
        var self = this;
        this.onChange('legalProvince');
        self.districtOpt = [];
        if(text){
            this.legalCity = "";
            this.legalArea = "";
        }
        this.getCity(code);
    },
    getDistrict(code){
        this.districtOpt = [];
        CreateAccount.getDistrict({"city_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.districtOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    getCity(code){
        this.cityOpt = [];
        CreateAccount.getCity({"province_id":code}).then(response => {
            const data = response.data.data;
            data.forEach(item => {
                this.cityOpt.push({"id":item.value,"text":item.text,"code":item.code});
            });
        }).catch(err => {
            this.checkError(err);
        });
    },
    onChange(name){
        this.error[name]="";
    },
    validate(){
        let success = true;
        let self = this;
        Object.keys(this.params).forEach(function(key) {
            console.log(key+":"+self.params[key]);
            if(self.params.legalIdType==2 && key == "legalIdReverse"){
                self.error[key]="";
            }
            else if(self.params[key]=='' || self.params[key]==null){
                self.error[key]="can not be blank.";
                success = false;
            }
        });

        return success;
    },
    uploadFile(account_id,user_no){
        let self = this;
        this.success = null;

        this.accountId = account_id;
        this.userNo = user_no;
        
        this.error.legalIdFront='';
        this.error.legalIdHold='';
        this.error.legalIdReverse='';

        let fileList = [
            {
                "type":(self.params.legalIdType==1)?2:5,
                "maxSize":self.maxSize*1024*1024,
                "file":self.params.legalIdFront
            },
            {
                "type":(self.params.legalIdType==1)?4:6,
                "maxSize":self.maxSize*1024*1024,
                "file":self.params.legalIdHold
            }
        ];

        if(self.params.legalIdType==1){
            fileList.push(
                {
                    "type":3,
                    "maxSize":self.maxSize*1024*1024,
                    "file":self.params.legalIdReverse
                }
            );
        }

        CreateAccount.uploadFile({
            "accountId":self.accountId,
            "userNo":""+self.userNo,
            "fileUpload":fileList
        }).then(response => {
            const data = response.data.data;
            let fileList = data["file"];
            for(let i=0;i<fileList.length;i++){
                if(fileList[i].type==2 || fileList[i].type==5){
                    // self.params.legalIdFront = fileList[i].file;
                    self.file.legalIdFront = fileList[i].fileId;
                }
                else if(fileList[i].type==4 || fileList[i].type==6){
                    // self.params.legalIdHold = fileList[i].file;
                    self.file.legalIdHold = fileList[i].fileId;
                }
                else if(fileList[i].type==3){
                    // self.params.legalIdReverse = fileList[i].file;
                    self.file.legalIdReverse = fileList[i].fileId;
                }
            }
            self.success = true;
            self.$emit('file-uploaded');
        }).catch(err => {
            self.checkError(err);
        });
    },
    checkError(err){
        try{
            let self = this;
            const response = err.response;  
            if(response.status == 400){
                if(typeof response.data.message === 'string'){
                    this.$notify({
                        type: 'warn',
                        text: response.data.message
                    });
                }
                else{
                    if(response.data.message['file']){
                        let fileList = response.data.message['file'];
                        for(let i=0;i<fileList.length;i++){
                            if(fileList[i].type==2 || fileList[i].type==5){
                                self.error.legalIdFront=fileList[i].message;
                            }
                            else if(fileList[i].type==4 || fileList[i].type==6){
                                self.error.legalIdHold=fileList[i].message;
                            }
                            else if(fileList[i].type==3){
                                self.error.legalIdReverse=fileList[i].message;
                            }
                        }
                    }
                    self.success = false;
                    self.$emit('file-uploaded');
                }
            }      
            else if(response.status == 401 && response.data.name == "Unauthorized"){
                    localStorage.removeItem("token");
                    localStorage.removeItem("member");
                    localStorage.removeItem("isFirstTime");
                    this.$router.push({ 
                        path: '/login', 
                    });
            }
            else{
                if(localStorage.getItem("token")){
                    var msg = (response.data)?response.data.message:err.message;
                    this.$notify({
                        type: 'warn',
                        text: msg
                    })
                }
            }
        }catch(e){
            console.log(err);
        }
    },
    togglePopup(index){
        this['showPopup_'+index]=!this['showPopup_'+index];
    },
    selectedDocument(data){
        console.log(data);
        this.params.legalIdType = data;
        this.error.legalIdType = "";
    },
    captureFile($event,key) {
        this.params[key]=$event;
        this.error[key]="";
    },
    removeImage($event,key){
        this.error[key]="";
    },
    doEscapeMarkup(markup){
        return markup;
    }
  },
  mounted(){
        let self = this;
        this.$nextTick(() => {
        
            CreateAccount.getProvince({"country":"CHN"}).then(response => {
                const data = response.data.data;
                this.provinceOpt = [];
                data.forEach(item => {
                    this.provinceOpt.push({"id":item.value,"text":item.text,"code":item.id});    
                });
                
                if(this.information){
                    
                    Object.keys(this.params).forEach(function(key) {
                        if(typeof self.file[key]!=="undefined" && self.information[key]){
                            self.file[key]=self.information[key];
                            self.getFile(key,self.information[key]);
                        }
                        else{
                            self.params[key]=self.information[key];
                        }
                    });

                    if(self.information['legalIdType']){
                        self.$refs['doc_type'].doc_type = parseInt(self.information['legalIdType']);
                    }
                    else{
                        self.$refs['doc_type'].doc_type = "";
                    }
                    
                    if(this.params.legalIdType){
                        let data_province = this.params.legalProvince.split("_");
                        this.getCity(data_province[0]);
                    }
                    
                    if(this.params.directorCity){
                        let data_city = this.params.legalCity.split("_");
                        this.getDistrict(data_city[0]);
                    }
                }

                if(this.user_no){
                    this.userNo = this.user_no;
                    this.accountId = this.account_id;
                }

            }).catch(err => {
                this.checkError(err);
            });
        });
    }
}
</script>

<style>
.form-group{
    margin-bottom: 0 !important;
}
</style>